/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Video_UploadInputs */

const en_embed_captions_video_upload = /** @type {(inputs: Embed_Captions_Video_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Upload`)
};

const fr_embed_captions_video_upload = /** @type {(inputs: Embed_Captions_Video_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Televersement video`)
};

const de_embed_captions_video_upload = /** @type {(inputs: Embed_Captions_Video_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video-Upload`)
};

const it_embed_captions_video_upload = /** @type {(inputs: Embed_Captions_Video_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento video`)
};

const ru_embed_captions_video_upload = /** @type {(inputs: Embed_Captions_Video_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка видео`)
};

const es_embed_captions_video_upload = /** @type {(inputs: Embed_Captions_Video_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir vídeo`)
};

const zh_cn2_embed_captions_video_upload = /** @type {(inputs: Embed_Captions_Video_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频上传`)
};

const ja_embed_captions_video_upload = /** @type {(inputs: Embed_Captions_Video_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオアップロード`)
};

const hi_embed_captions_video_upload = /** @type {(inputs: Embed_Captions_Video_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो अपलोड`)
};

const pt_pt2_embed_captions_video_upload = /** @type {(inputs: Embed_Captions_Video_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload de vídeo`)
};

/**
* | output |
* | --- |
* | "Video Upload" |
*
* @param {Embed_Captions_Video_UploadInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_video_upload = /** @type {((inputs?: Embed_Captions_Video_UploadInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Video_UploadInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_video_upload(inputs)
	if (locale === "de") return de_embed_captions_video_upload(inputs)
	if (locale === "it") return it_embed_captions_video_upload(inputs)
	if (locale === "ru") return ru_embed_captions_video_upload(inputs)
	if (locale === "es") return es_embed_captions_video_upload(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_video_upload(inputs)
	if (locale === "ja") return ja_embed_captions_video_upload(inputs)
	if (locale === "hi") return hi_embed_captions_video_upload(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_video_upload(inputs)
	return en_embed_captions_video_upload(inputs)
});